Ext.define('SA.HistogramModelState', {
    singleton: true,

    get(model) {
        return {
            attributes: this.getAttributesState(model),
            barColor: model.data.barColor,
            binSize: this.getBinSizeState(model),
            chartTitle: model.data.title,
            geoUnits: this.getGeoUnitsState(model),
            idPromise: model.getIdPromise(),
            locations: this.getLocationsState(model),
            projectName: model.getProject().getName(),
            viewable: model.isViewable(),
            viewName: model.getName(),
            yAxisTitle: this.getYAxisTitle(model)
        };
    },

    getAttributesState(model) {
        var selectedId = model.getAttribute(),
            censusRelease = model.getCensusRelease(),
            attributes = model.getProjectAttributes(),
            isSupported = attribute => SA.HistogramAttributes.isSupported({attribute, censusRelease}),
            supportedIds = attributes.filter(isSupported),
            unsupportedIds = attributes.filter(attribute => !isSupported(attribute)),
            formatter = SA.NumberFormatter.forAttribute(selectedId),
            label = SA.data.AttributesCache.getLabel(selectedId),
            selected = {id: selectedId, formatter, label};

        return {selected, supported: {ids: supportedIds}, unsupported: {ids: unsupportedIds}};
    },

    getBinSizeState(model) {
        var size = model.data.binSize,
            isCustom = size !== null,
            attribute = model.getAttribute(),
            format = SA.data.AttributesCache.getFormat(attribute),
            supportsFractions = SA.data.AttributesCache.supportsFractions(attribute);

        return {format, isCustom, supportsFractions, size};
    },

    getGeoUnitsState(model) {
        var selected = model.getGeoUnit(),
            supportedDiscoverable = model.getSupportedDiscoverableGeoUnits();

        return {selected, supportedDiscoverable};
    },

    getLocationsState(model) {
        var selectedId = model.getLocation(),
            country = model.getCountry(),
            censusRelease = model.getCensusRelease(),
            projectLocations = model.getProjectLocations(),
            getAlias = location => SA.data.LocationAliases.get(location),
            isSupported = location => SA.HistogramLocations.isSupported({country, censusRelease, location}),
            supportedIds = projectLocations.filter(isSupported),
            unsupportedIds = projectLocations.filter(location => !isSupported(location)),
            isCombo = SA.data.LocationsCache.isComboLocation(selectedId),
            comboConstituents = !isCombo ? [] : SA.data.LocationsCache.getConstituentSeries(selectedId),
            selected = {id: selectedId, alias: getAlias(selectedId), comboConstituents},
            supported = {ids: supportedIds, aliases: supportedIds.map(getAlias)},
            unsupported = {ids: unsupportedIds, aliases: supportedIds.map(getAlias)};

        return {selected, supported, unsupported};
    },

    getYAxisTitle(model) {
        var geoUnit = SA.data.GeographicUnits.get(model.getGeoUnit()),
            location = SA.data.LocationsCache.get(model.getLocation());

        if (!geoUnit || !location) {
            return null;
        }
        else if (location.type === 'radius') {
            return `Count of ${geoUnit.name} ${location.name}`; 
        }

        return `Count of ${geoUnit.name} in ${location.name}`;
    }
});